import { ThemeOptions } from "@mui/material/styles";

export const menuItemOverrides: ThemeOptions["components"] = {
	MuiMenuItem: {
		styleOverrides: {
			root: ({ theme }) => ({
				paddingTop: theme.spacing(3),
				paddingBottom: theme.spacing(3),
				fontWeight: 500,
				fontSize: theme.typography.pxToRem(14),
				color: theme.palette.common.black,
				lineHeight: "120%",

				"&:hover, &.Mui-focusVisible": {
					backgroundColor: theme.palette.dirtyWhite["200"],
				},
			}),
		},
	},
};
